const transitions = {
    active_projects:{
        share_for_review_compliance_document: 'share_for_review_compliance_document',
        /** Compliance Documents: Share for review → activity_proceed_to_vendor_assessment (label: initiate_vendor_tasks) */
        initiate_vendor_tasks: 'initiate_vendor_tasks',
        review_complete_compliance_document: 'review_complete_compliance_document',
        request_for_revision_compliance_document: 'request_for_revision_compliance_document',
        disable_review_complete_compliance_document: 'disable_review_complete_compliance_document',
        
        share_for_review_product_specification: 'share_for_review_product_specification',
        request_for_revision_main_details: 'request_for_revision_main_details',
        review_complete_main_details: 'review_complete_main_details',
        disable_review_complete_main_details: 'disable_review_complete_main_details',

        // nt_review_complete_recipe: 'nt_review_recipe',
        nt_review_complete_recipe: 'nt_review_complete_recipe',
        // nt_request_revision_recipe: 'nt_request_revision_recipe',
        nt_request_for_revision_recipe: 'nt_request_for_revision_recipe',
        disable_nt_review_complete_recipe: 'disable_nt_review_complete_recipe',
        nt_review_complete_raw_materials: 'nt_review_complete_raw_materials',
        nt_request_for_revision_raw_materials: 'nt_request_for_revision_raw_materials',
        nt_revision_review_raw_materials: 'nt_revision_review_raw_materials',
        disable_nt_review_complete_raw_materials: 'disable_nt_review_complete_raw_materials',
        
        nt_share_for_review_recipe_raw_materials:'nt_share_for_review_recipe_raw_materials',
        nt_review_complete_recipe_raw_materials : 'nt_review_complete_recipe_raw_materials',
        nt_request_for_revision_recipe_raw_materials : 'nt_request_for_revision_recipe_raw_materials',
        disable_nt_review_complete_recipe_raw_materials :'disable_nt_review_complete_recipe_raw_materials',
        
        nt_review_complete_nutrition: 'nt_review_complete_nutrition',
        nt_request_for_revision_nutrition: 'nt_request_for_revision_nutrition',
        nt_revision_review_nutrition: 'nt_revision_review_nutrition',
        disable_nt_review_complete_nutrition: 'disable_nt_review_complete_nutrition',

        // Unified workflow (new GET endpoint labels)
        review_complete_data: 'review_complete_data',
        nt_review_complete: 'nt_review_complete',
        nt_request_for_revision: 'nt_request_for_revision',
        tm_review_complete: 'tm_review_complete',
        tm_request_for_revision: 'tm_request_for_revision',
        nt_review_again: 'nt_review_again',
        tm_review_again: 'tm_review_again',
        vo_ps_data_review: 'vo_ps_data_review',
        share_for_review_data: 'share_for_review_data',
        nt_share_for_review: 'nt_share_for_review',
        tm_share_for_review: 'tm_share_for_review',
        qa_review_again: 'qa_review_again',
        request_for_revision_data: 'request_for_revision_data',
        request_revisions: 'request_revisions',
        request_updates: 'request_updates',
        /** Launched Products — Packaging listing GET: legacy key (prefer `request_version` for new version flow) */
        request_revision: 'request_revision',
        /** Launched Products — Packaging "Request for new version": API uses same string for transitionId and label */
        request_version: 'request_version',
        /** Launched Products — initiate product discontinuation */
        request_to_discontinued: 'request_to_discontinued',
        /** Cancel in-flight discontinuation request */
        cancel_to_discontinued_process: 'cancel_to_discontinued_process',
        /** Confirm / complete discontinuation (legacy label) */
        complete_discontinuation: 'complete_discontinuation',
        /** Complete discontinuation — current API label */
        proceed_to_discontinued: 'proceed_to_discontinued',
        /** Cancel project during discontinuation workflow */
        cancel_project: 'cancel_project',
        /** Return discontinuation request */
        return_to_discontinued: 'return_to_discontinued',
        /** Packaging listing: share-for-review after a new version workflow step */
        version_share_for_review: 'version_share_for_review',
        approve: 'approve',
        acknowledge: 'acknowledge',
        // Unified workflow disable labels (new GET endpoint labels)
        disable_review_complete_data: 'disable_review_complete_data',
        disable_nt_review_complete: 'disable_nt_review_complete',
        disable_tm_review_complete: 'disable_tm_review_complete',
        disable_finalize_and_submit: 'disable_finalize_and_submit',

        
        nt_review_complete_allergens_and_sensitivities: 'nt_review_complete_allergens_and_sensitivities',
        nt_request_revision_allergens_and_sensitivities: 'nt_request_for_revision_allergens_and_sensitivities',
        nt_revision_review_allergens_and_sensitivities: 'nt_revision_review_allergens_and_sensitivities',
        disable_nt_review_complete_allergens_and_sensitivities: 'disable_nt_review_complete_allergens_and_sensitivities',
        request_new_site: 'request_new_site',
        generate_nt_pack_copy :'generate_nt_pack_copy',
        nt_request_revision_nutrition_pack_copy: 'nt_request_for_revision_nutrition',

        share_for_review: 'share_for_review',
        // Food Safety (Review Complete)
        // Back-compat: `qa_review_complete_food_safety_qa` key remains, but the label is `review_complete_food_safety_qa`.
        qa_review_complete_food_safety_qa: 'review_complete_food_safety_qa',
        review_complete_food_safety_qa: 'review_complete_food_safety_qa',
        qa_request_revision_food_safety_qa: 'request_for_revision_food_safety_qa',
        request_for_revision_food_safety_qa: 'request_for_revision_food_safety_qa',
        qa_revision_review_food_safety_qa: 'qa_revision_review_food_safety_qa',
        disable_review_complete_food_safety_qa: 'disable_review_complete_food_safety_qa',

        tm_review_complete_storage: 'tm_review_complete_storage',
        tm_request_revision_storage: 'tm_request_for_revision_storage',
        tm_revision_review_storage: 'tm_revision_review_storage',
        disable_tm_review_complete_storage: 'disable_tm_review_complete_storage',
        nt_request_revision_raw_materials:'nt_request_revision_raw_materials',


        
        share_for_review_main_details: 'share_for_review_main_details',
        nt_share_for_review_recipe: 'nt_share_for_review_recipe',
        nt_share_for_review_raw_materials: 'nt_share_for_review_raw_materials',
        nt_share_for_review_nutrition: 'nt_share_for_review_nutrition',
        nt_request_for_revision_allergens_and_sensitivities: 'nt_request_for_revision_allergens_and_sensitivities',
        nt_share_for_review_allergens_and_sensitivities: 'nt_share_for_review_allergens_and_sensitivities',
        share_for_review_food_safety_qa: 'share_for_review_food_safety_qa',
        tm_request_for_revision_storage: 'tm_request_for_revision_storage',
        tm_share_for_review_storage: 'tm_share_for_review_storage',
        approve_glc: 'approve_glc',

        // Workflow statuses (non-transition labels) - used for UIR substatuses
        // Kept here as a single source of truth to avoid hardcoding.
        ps_nt_review: 'ps_nt_review',
        ps_nt_request_revision: 'ps_nt_request_revision',
        ps_nt_review_complete: 'ps_nt_review_complete',

        ps_tm_review: 'ps_tm_review',
        ps_tm_request_revision: 'ps_tm_request_revision',
        ps_tm_review_complete: 'ps_tm_review_complete',

        ps_qa_review_food_safety_qa: 'ps_qa_review_food_safety_qa',
        ps_qa_request_revision_food_safety_qa: 'ps_qa_request_revision_food_safety_qa',
        ps_qa_review_complete_food_safety_qa: 'ps_qa_review_complete_food_safety_qa',

        ps_glc_review: 'ps_glc_review',
        ps_glc_reviewed: 'ps_glc_reviewed',

        ps_all_review_completed: 'ps_all_review_completed',

        // NOTE: legacy status value (different from `generate_nt_pack_copy`)
        generated_nt_pack_copy: 'generated_nt_pack_copy',
        
        // Request New Site transitions
        request_new_site_details_developer_review: 'request_new_site_details_developer_review',
        request_new_site_details_nt_internal_review: 'request_new_site_details_nt_internal_review',
        request_new_site_details_qa_internal_review: 'request_new_site_details_qa_internal_review',
        request_new_site_details_tm_internal_review: 'request_new_site_details_tm_internal_review',
        
    },
    vendor_onboarding: {
        share_for_review: 'share_for_review',
        review_complete: 'review_completed',
        request_for_revision: 'request_for_revision',
        share_for_review_food_safety_qa: 'share_for_review_food_safety_qa',
        vendor_contacts: 'vendor_contacts'
    },
    artwork: {
        artwork_complete: 'artwork_complete',
        request_artwork_revision: 'request_artwork_revision',
    },
    /** Site audit details form — values must match BE `availableTransitions.data[].label`. */
    audits_and_visits: {
        initiate_audit: 'initiate_audit',
        approve_audit: 'approve_audit',
        unlock_audit: 'unlock_completed_audit',
        cancel_audit: 'cancelled_audit',
        request_for_revision: 'request_revision',
        approve_extension_request: 'approve_extension_request',
        deny_extension_request: 'deny_extension_request',
        approve_letter_of_intent_request: 'approve_letter_of_intent_request',
        deny_letter_of_intent_request: 'deny_letter_of_intent_request',
        recomplete: 'recomplete_audit_for_review',
        submit_for_review: 'submit_audit_for_review',
        extension_letter_review: 'extension_letter_review',
        letter_of_intent_review: 'letter_of_intent_review',
    },
}

export default transitions;




// nt_review_complete_raw_materials
// nt_request_revision_raw_materials
// nt_revision_review_raw_materials
 
 
// nt_review_complete_allergens_and_sensitivities
// nt_request_revision_allergens_and_sensitivities
// nt_revision_review_allergens_and_sensitivities
 
 
// nt_review_complete_nutrition
// nt_request_revision_nutrition
// nt_revision_review_nutrition
 
 

// nt_review_complete_nutrition_pack_copy
// nt_request_revision_nutrition_pack_copy
// nt_revision_review_nutrition_pack_copy
 
 
// qa_review_complete_food_safety_qa
// qa_request_revision_food_safety_qa
// qa_revision_review_food_safety_qa
 
 
// tm_review_complete_storage
// tm_request_revision_storage
// tm_revision_review_storage
 
 
